/**
 * Service API pour la configuration de l'application (admin)
 * @module admin/services/appConfigService
 */

import { apiGet, apiPut } from '../../../utils/api';

/**
 * Récupère la configuration actuelle
 * @returns {Promise<Object>}
 */
export const getAppConfig = async () => {
  const response = await apiGet('/admin/config');
  return response.data;
};

/**
 * Met à jour la configuration
 * @param {Object} config - champs optionnels dont premiumFeatureFlags (partiel)
 * @returns {Promise<Object>}
 */
export const updateAppConfig = async (config) => {
  const response = await apiPut('/admin/config', config);
  return response.data;
};
